/**
 * JS inteface for the Chat tool.
 */
window.diy = window.diy || {};
window.diy.editor = window.diy.editor || {};
window.diy.editor.chat = window.diy.editor.chat || {};
(function() {

    // local globals //
    var YALST_INSTALLATION_URL, YALST_SITE, YALST_DEPT, bootstrapYalst, initParams;

    /**
     * Setup initial objects needed by the yalst library and loader.
     */
    bootstrapYalst = function () {
        if (typeof LiveSupport == "undefined"){
            LiveSupport = {};
        }
        if (typeof LiveSupport.VisitorAPI == "undefined"){
            LiveSupport.VisitorAPI = {};
        }
        if (typeof LiveSupport.VisitorAPI._methodQueue == "undefined"){
            LiveSupport.VisitorAPI._methodQueue = [];
        }
        if (typeof LiveSupport.VisitorAPI.invoke === 'undefined') {
            LiveSupport.VisitorAPI.invoke = function (method, parameterArray, callback) {
                if (typeof method != "string"){
                    if (typeof callback == "function"){
                        callback(new Error("invalid argument: 1 must be string"));
                    }
                    return;
                }
                LiveSupport.VisitorAPI._methodQueue.push({
                    method: method,
                    parameters: parameterArray,
                    callback: callback
                });
            };
        }
    };

    // possible operator statuses //
    this.OPERATOR_STATUS_AVAILABLE = 'online';
    this.OPERATOR_STATUS_OFFLINE = 'offline';

    /**
     * Includes and bootstraps the yalst LiveSupport library.
     *
     * @param params
     * @param callback
     */
    this.init = function (params, callback) {
        var anchorElement, script;

        initParams = params;
        YALST_INSTALLATION_URL = params['url'];
        YALST_SITE = params['site'];
        YALST_DEPT = params['dept'];

        // setup yalst namespace //
        bootstrapYalst();

        // initialize the yalst API //
        anchorElement = document.getElementsByTagName('script')[0];
        script = document.createElement("script");
        script.src = YALST_INSTALLATION_URL + "visitor_api/v2/built/LiveSupport.js";
        script.setAttribute("data-main", YALST_INSTALLATION_URL + "visitor_api/v2/built/LiveSupportMain");
        anchorElement.parentNode.insertBefore(script, anchorElement);

        // the first method that must be called before calling any other method of the API
        // we call it through 'invoke' as the API may not have finished loading
        LiveSupport.VisitorAPI.invoke(
            'associateWithLiveSupportProduct',
            [YALST_INSTALLATION_URL, YALST_SITE],
            function() {
                // once the product is associated we must start 'controlling' //
                LiveSupport.VisitorAPI.startControlling(YALST_DEPT, null, function() {
                    if (callback && callback.call) {
                        callback(true); // the parameter is just for compatibility with the generic interface of this method //
                    }
                });
            }
        );
    };

    /**
     * Checks if any operator is available to chat.
     *
     * @param callback
     */
    this.checkAvailability = function (callback) {
        LiveSupport.VisitorAPI.getOperatorAvailability(function(operatorStatus) {
            var status;

            if (operatorStatus == LiveSupport.VisitorAPI.Availability.AVAILABLE) {
                status = diy.editor.chat.OPERATOR_STATUS_AVAILABLE;
            } else {
                status = diy.editor.chat.OPERATOR_STATUS_OFFLINE;
            }

            callback(status);
        }, YALST_DEPT);
    };

    /**
     * Opens the chat window.
     */
    this.startChat = function () {
        LiveSupport.VisitorAPI.startLiveChat(
            YALST_DEPT,
            {
                paddfields: (initParams && initParams.hasOwnProperty('agentMessage')) ? (initParams.agentMessage || '') : '',
                direct: (initParams && initParams.hasOwnProperty('direct')) ? (initParams.direct || '') : '',
                name: ''
            }
        );
    };

    /**
     * Combo method - combines init and start
     * @param params
     */
    this.triggerChat = function (params) {
        if (typeof LiveSupport === 'undefined') {
            this.init(
                params,
                function() {
                    diy.editor.chat.startChat();
                }
            );
        } else {
            this.startChat();
        }
    };

    return this;

}).call(diy.editor.chat);


/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/js/chat/yalst.js
 ** module id = 927
 ** module chunks = 0
 **/